var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"#f8f8f8","height":"100vh"}},[(_vm.flag)?_c('Header'):_c('HeaderPc'),(_vm.flag)?_c('GetMyDemo'):_c('GetMyDemoPc')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }